var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"stop-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19"}},[_c('rect',{attrs:{"fill":_vm.color,"x":"6","y":"6","width":"12","height":"12"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }